var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autorun, computed, observable } from "mobx";
import { OnChainPermissions } from "healthex-common/auth.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { UserPermissions } from "healthex-common/user.dtos";
export const PASSWORD_PLACEHOLDER = "****************";
export class GlobalAdminUserFormModelBase {
    get showFullDetail() {
        return this.opts.mode !== "new" && this.opts.mode !== "initialUser";
    }
    constructor(opts) {
        this.opts = opts;
        this.editing = opts.mode === "new" || opts.mode === "initialUser";
        window.setTimeout(() => {
            autorun(() => {
                if (opts.mode === "detail") {
                    void this.loadUser(opts.organizationId, opts.userId, false);
                }
            });
        }, 0);
    }
    cancel() {
        if (this.opts.mode === "new") {
            this.opts.onCancel();
        }
        else {
            this.editing = false;
        }
    }
    async save() {
        if (this.opts.mode === "new") {
            const userId = await this.performCreate();
            await this.loadUser(this.opts.organizationId, userId, true);
            this.opts.onCreate(userId);
        }
    }
    async forcePasswordChange() {
        if (this.opts.mode === "detail") {
            await this.forcePasswordReset();
        }
    }
    describePermission(permission) {
        switch (permission) {
            case UserPermissions.ORG_ADMIN:
                return "IT Admin";
            case UserPermissions.RESEARCH_ADMIN:
                return "Research Admin";
            case UserPermissions.GLOBAL_PROVISIONING:
                return "System-wide Provisioning";
            case OnChainPermissions.ON_CHAIN_ACTIONS:
                if (this.editing) {
                    return "Perform Auditable Actions that are recorded to the Blockchain Ledgers (ex. Approving Studies for Data Access, Requesting Patient Consent)";
                }
                else {
                    return "Perform On-Chain Actions";
                }
            case UserPermissions.NONE:
            case UserPermissions.PASSWORD_RESET:
            case UserPermissions.INVITE_USER:
            case UserPermissions.RESEARCHER:
            case UserPermissions.PROVIDER:
                return null;
        }
        return willNeverHappen(permission);
    }
    get showOnChainUI() {
        if (!this.showFullDetail) {
            return false;
        }
        return false;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminUserFormModelBase.prototype, "showFullDetail", null);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], GlobalAdminUserFormModelBase.prototype, "editing", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], GlobalAdminUserFormModelBase.prototype, "showOnChainUI", null);
